import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { Flex, Box } from 'grid-styled'
import { connect } from 'react-redux'
import { utils } from 'alelo-logic'
import Button from '../../elements/Button'

import {
  renderTextInput,
  renderTelephoneField,
  renderCheckboxField,
  renderTelephoneTypesField
} from '../../../utils/renderInputs'

import { errorMessage } from '../../../utils/dictionary'

import { Container, Text } from '../EditUserDataForm/styles'

import { labels } from './data.json'

const validate = (values, props) => {
  const errors = {}

  if (!values.telephoneType) {
    errors.telephoneType = errorMessage.required
  }

  if (!values.telephone) {
    errors.telephone = errorMessage.required
  }

  if (
    props.initialValues &&
    values.email !== props.initialValues.email &&
    values.email !== values.validEmail
  ) {
    errors.email = errorMessage.emailDifferent
  }

  if (props.initialValues && values.email !== values.validEmail) {
    errors.validEmail = errorMessage.different
  }

  return errors
}

const preventDefault = e => {
  e.preventDefault()
  const currentValue = e.target.value
  e.target.value = ''
  e.target.value = currentValue
}

const EditAdminContactForm = props => {
  const { handleSubmit, saving } = props

  return (
    <form onSubmit={handleSubmit}>
      <Container>
        <Flex wrap width={[1, 7 / 12]}>
          <Box width={1} mb={3}>
            <Field
              component={renderTextInput}
              label={labels.name}
              validate={utils.emptyFieldValidate}
              name="name"
              type="text"
              isRequired
            />
          </Box>
          <Box width={1} mb={3}>
            <Field
              component={renderTextInput}
              label={labels.email}
              validate={utils.emailValidate}
              name="email"
              type="text"
              onPaste={e => preventDefault(e)}
              isRequired
            />
          </Box>
          <Box width={1} mb={3}>
            <Field
              component={renderTextInput}
              label={labels.validateEmail}
              validate={utils.emailValidate}
              name="validEmail"
              type="text"
              onPaste={e => preventDefault(e)}
              isRequired
            />
          </Box>
          <Box width={1} mb={3}>
            <Field
              component={renderTextInput}
              label={labels.site}
              validate={utils.emptyFieldValidate}
              name="site"
              type="text"
              isRequired
            />
          </Box>
          <Box width={[1, 1 / 2]} pr={[0, 2]} mb={3}>
            <Field
              component={renderTelephoneField}
              label={labels.telephone}
              name="telephone"
              type="text"
              isRequired
            />
          </Box>
          <Box width={[1, 1 / 6]} pr={[0, 2]} mb={3}>
            <Field component={renderTextInput} label={labels.line} name="line" type="text" />
          </Box>
          <Box width={[1, 1 / 3]} mb={3}>
            <Field
              component={renderTelephoneTypesField}
              label={labels.telephoneType}
              name="telephoneType"
              isRequired
              id="tipoDoTelefone"
            />
          </Box>
          <Box width={[1, 1 / 2]} pr={[0, 2]} mb={3}>
            <Field
              component={renderTelephoneField}
              label={labels.cellphone}
              name="cellphone"
              type="text"
            />
          </Box>
          <Box width={1} mb={3}>
            <Field
              component={renderCheckboxField}
              label={labels.promotions}
              name="optInPromotions"
            />
          </Box>
          <Box width={1} mb={3}>
            <Text>* Caso altere seu email, você será deslogado automaticamente.</Text>
          </Box>
        </Flex>
      </Container>
      <Container>
        <Button type="submit" text="Salvar" disabled={saving || !props.valid} loading={saving} />
      </Container>
    </form>
  )
}

const mapStateToProps = state => {
  return {
    saving: state.reducer.formState.saving
  }
}

const form = reduxForm({
  form: 'editAdminContactForm',
  destroyOnUnmount: false,
  validate
})(EditAdminContactForm)

export default connect(mapStateToProps, undefined)(form)



// WEBPACK FOOTER //
// ./src/app/modules/EditAdminContactForm/index.js